import React from 'react';
import Button from 'src/components/Button/Button';
import LoadingButton from 'src/components/BulkOperations/_Shared/BulkActionButton/LoadingButton';
import './bulk-wizard-footer.scss';

/* Domain-agnostic stepper footer for the bulk-toggle wizard dialogues.
 * Keeps its own step constants so it doesn't couple to any one dialogue's
 * form-state — the shipped Email dialogue will migrate onto this in Phase 4. */

export type WizardStepId = 1 | 2 | 3;

const STEP_PICK: WizardStepId = 1;
const STEP_REVIEW: WizardStepId = 2;
const STEP_CONFIRMATION: WizardStepId = 3;

interface BulkWizardFooterProps {
  currentStep: WizardStepId;
  canContinue: boolean;
  canApply: boolean;
  isSubmitting: boolean;
  applyLabel?: string;
  onCancel: () => void;
  onBack: () => void;
  onContinue: () => void;
  onApply: () => void;
  onDone: () => void;
}

const BulkWizardFooter = ({
  currentStep,
  canContinue,
  canApply,
  isSubmitting,
  applyLabel = 'Apply changes',
  onCancel,
  onBack,
  onContinue,
  onApply,
  onDone,
}: BulkWizardFooterProps) => {
  if (currentStep === STEP_PICK) {
    return (
      <div className="bwf-footer">
        <div className="bwf-footer-left" />
        <div className="bwf-footer-right">
          <Button color="white" size="small" label="Cancel" onClick={onCancel} />
          <Button
            color="teal"
            size="small"
            label="Next"
            onClick={onContinue}
            disabled={!canContinue}
          />
        </div>
      </div>
    );
  }

  if (currentStep === STEP_REVIEW) {
    return (
      <div className="bwf-footer">
        <div className="bwf-footer-left">
          <Button
            color="white"
            size="small"
            label="← Back"
            onClick={onBack}
            disabled={isSubmitting}
          />
        </div>
        <div className="bwf-footer-right">
          <Button
            color="white"
            size="small"
            label="Cancel"
            onClick={onCancel}
            disabled={isSubmitting}
          />
          <LoadingButton
            actionText={applyLabel}
            isSubmitting={isSubmitting}
            disabled={!canApply}
            onClick={onApply}
          />
        </div>
      </div>
    );
  }

  if (currentStep === STEP_CONFIRMATION) {
    return (
      <div className="bwf-footer">
        <div className="bwf-footer-left" />
        <div className="bwf-footer-right">
          <Button color="teal" size="small" label="Done" onClick={onDone} />
        </div>
      </div>
    );
  }

  return null;
};

export default BulkWizardFooter;